import { Injectable } from '@angular/core';
import { StudentDataType } from 'src/app/models/enums/StudentDataType';
import { Filter } from 'src/app/shared/interfaces/filter';

@Injectable({
  providedIn: 'root',
})
export class FiltersColorHelper {
  static defaultColorsList: any = {
    exams: {
      primary: '#FF9900',
      secondary: '#FF99002E',
    },
    assignments: {
      primary: '#BA73E5',
      secondary: '#BA73E526',
    },
    academicEvents: {
      primary: '#1BA9F9',
      secondary: '#1BA9F91A',
    },
    lessons: {
      primary: '#0237C0',
      secondary: '#0237c008',
    },
  };

  static defaultColor: string = FiltersColorHelper.defaultColorsList.exams.primary;

  static convertToFilterArr(filters: any): Filter[] {
    return filters.map((x: { id: any; studentTypes: any; label: any; color: any; isEnabled: any; }) => {
        return {
          value: x.id,
          valueArr: x.studentTypes,
          label: x.label,
          color: x.color,
          checked: x.isEnabled
        }
      });
  }

  static convertToCheckboxEnumArr(filters: Filter[]): StudentDataType[] {
    return filters.filter(c => c.checked).reduce<StudentDataType[]>((acc, filter) => [...acc, ...filter.valueArr!], []);
  }

  static convertStudentDataTypeToArr(): StudentDataType[] {
    return  Object.keys(StudentDataType).filter((key) => isNaN(Number(key))).map(key => StudentDataType[key as any]) as unknown as StudentDataType[];
  }

  static rgba(hex: string, opacity: number): string {
    hex = hex.replace('#', '');
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    return `rgba(${r},${g},${b},${opacity})`;
  }

  static getStyleColor(color: string | undefined): string {
    if (!color) return '';
    return color.indexOf('#') !== -1 ? color : `#${color}`;
  }

  static getPrimaryColor(type: number, filters: any): string {
    let filter = filters.find((item: any) => item.studentTypes.includes(type));
    let color = filter && filter.color ? filter.color : this.defaultColor;
    return color.indexOf('#') !== -1 ? color : `#${color}`;
  }

  static getSecondaryColor(type: number, filters: any): string {
    let color = FiltersColorHelper.getPrimaryColor(type, filters);
    return FiltersColorHelper.rgba(color, 0.1);
  }
}
